import { createReducer } from '@reduxjs/toolkit';
import { persistReducer, purgeStoredState } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { createTableStateReducers } from '@/store/tableState.reducer';
import t from '@/store/types';

// Initial state.
const initialState = {
  tableState: {
    filterRoles: [],
  },
  selectedRows: [],
};

const STORAGE_KEY = 'leyona:itemCategories';

const CONFIG = {
  key: STORAGE_KEY,
  whitelist: [],
  storage,
};

const reducerInstance = createReducer(initialState, (builder) => {
  Object.entries(createTableStateReducers('ITEMS_CATEGORIES')).forEach(
    ([actionType, reducer]) => {
      builder.addCase(actionType, reducer);
    },
  );

  builder.addCase(
    'ITEMS_CATEGORIES/SET_SELECTED_ROWS',
    (state, action: any) => {
      state.selectedRows = action.payload;
    },
  );

  builder.addCase('ITEMS_CATEGORIES/RESET_SELECTED_ROWS', (state) => {
    state.selectedRows = [];
  });

  builder.addCase(t.RESET, () => {
    purgeStoredState(CONFIG);
  });
});

export default persistReducer(CONFIG, reducerInstance);
